<br>
<br>
<div class="content_bg styled-section">
  <ds-tabs>
    <ds-tabs-label for="waiting" [disabled]="!canManage" (click)="selectTab('waiting')">
      Users waiting for access
    </ds-tabs-label>
    <ds-tabs-content id="waiting">
      <div class="tab-content">
        <div *ngIf="usersWaitingForAccess.length > 0; else noUsersWaitingForAccess" class="table-section">
          <div class="table-scroll-container">
            <table  class="zebra-table fixed-header-table">
              <thead>
              <tr class="table_head">
                <th>User Id</th>
                <th>Name</th>
                <th>Surname</th>
                <th>Email Address</th>
                <th>Role</th>
                <th>Actions</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let user of usersWaitingForAccess">
                <td>{{ user.userId }}</td>
                <td>{{ user.name }}</td>
                <td>{{ user.surname }}</td>
                <td>{{ user.email }}</td>
                <td>{{ user.role }}</td>
                <td>
                  <ds-icon
                    icon="check"
                    size="lg"
                    title="Approve Member"
                    class="action-icon"
                    tone="positive"
                    (click)="onApprove(user)"
                    style="cursor:pointer; margin-right: 8px;"
                  ></ds-icon>
                  <ds-icon
                    icon="close"
                    title="Reject Member"
                    class="action-icon"
                    tone="critical"
                    size="lg"
                    (click)="onReject(user)"
                    style="cursor:pointer;"
                  ></ds-icon>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </ds-tabs-content>

    <!-- Tab 2: Active users at your agency -->
    <ds-tabs-label for="completed" (click)="onActiveUsersTabSelect()">
      Active users at your agency
    </ds-tabs-label>
    <ds-tabs-content id="completed">
      <div class="tab-content">
        <div *ngIf="activeUsersAtAgency.length > 0 ; else noActiveUsersAtAgency" class="table-section">
          <div class="table-scroll-container">
            <table  class="zebra-table fixed-header-table">
              <thead>
              <tr class="table_head">
                <th>Name</th>
                <th>Surname</th>
                <th>Email Address</th>
                <th>Role</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let user of activeUsersAtAgency">
                <td>{{ user.name }}</td>
                <td>{{ user.surname }}</td>
                <td>{{ user.email }}</td>
                <td>{{ user.role }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </ds-tabs-content>
  </ds-tabs>
</div>

<ng-template #noUsersWaitingForAccess>
  <ds-empty-state
    heading="No users waiting for access"
    description="There are currently no users waiting for access."
    footnote="Please check back later."
    illustration="create"
    size="lg"
  >
  </ds-empty-state>
</ng-template>
<ng-template #noActiveUsersAtAgency>
  <ds-empty-state
    heading="No active users at your agency"
    description="There are currently no active users at your agency."
    footnote="Please check back later."
    illustration="create"
    size="lg"
  >
  </ds-empty-state>
</ng-template>
